(function () {
  'use strict';
  angular
    .module('garanteasyApp')
    .factory('WarrantyClaimFile', WarrantyClaimFile);

  WarrantyClaimFile.$inject = ['$resource', 'API_URI'];

  function WarrantyClaimFile($resource) {
    var resourceUrl = API_URI + 'api/warranty-claim-files/:id';

    return $resource(resourceUrl, {}, {
      'query': {method: 'GET', isArray: true},
      'get': {
        method: 'GET',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'update': {method: 'PUT'}
    });
  }
})();
